export default function SpecsSkeleton() {
  return (
    <div className="specs-widget">
      <div className="grid grid-cols-3 gap-0 border border-border rounded-lg overflow-hidden">
        {/* Bedrooms Skeleton */}
        <div className="flex flex-col items-center p-6 border-r border-border">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 homerunner-specs-skeleton rounded"></div>
            <div className="w-12 h-10 homerunner-specs-skeleton rounded"></div>
          </div>
          <div className="w-20 h-4 homerunner-specs-skeleton rounded"></div>
        </div>

        {/* Bathrooms Skeleton */}
        <div className="flex flex-col items-center p-6 border-r border-border">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 homerunner-specs-skeleton rounded"></div>
            <div className="w-12 h-10 homerunner-specs-skeleton rounded"></div>
          </div>
          <div className="w-20 h-4 homerunner-specs-skeleton rounded"></div>
        </div>

        {/* Guests Skeleton */}
        <div className="flex flex-col items-center p-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 homerunner-specs-skeleton rounded"></div>
            <div className="w-12 h-10 homerunner-specs-skeleton rounded"></div>
          </div>
          <div className="w-20 h-4 homerunner-specs-skeleton rounded"></div>
        </div>
      </div>
    </div>
  )
}
